import React, { useMemo } from 'react';

import { useCurrentUser } from '../../../../hooks';
import { NewsletterSubscription } from '../../../../utils/backend-api/newsletters';
import { EmailSettings as EmailSettingsInterface } from '../../../../utils/backend-api/settings';
import EmailSettingsOption from './EmailSettingsOption';
import styles from './styles.module.scss';

interface EmailSettingsProps {
  newsletters: NewsletterSubscription[];
  userEmailSettings: EmailSettingsInterface;
}

const EmailSettings = ({ newsletters, userEmailSettings }: EmailSettingsProps) => {
  const { currentUser } = useCurrentUser();
  const emailSettings = useMemo(() => {
    return currentUser.is_subscriber || currentUser.comped
      ? [
          {
            accessLevel: 0,
            slug: 'articleNotifications',
            newsletterId: null,
            title: 'Major Articles',
            subheader: 'Get an email each time we publish a major article.',
            isSubscribed: userEmailSettings.articleNotifications === 'all',
            frequency: null,
          },
          ...newsletters,
        ]
      : newsletters;
  }, [
    currentUser.is_subscriber,
    currentUser.comped,
    newsletters,
    userEmailSettings.articleNotifications,
  ]);

  return (
    <div className={styles.emailOptionContainer}>
      {emailSettings.map((option) => (
        <EmailSettingsOption key={option.subheader} {...option} />
      ))}
    </div>
  );
};

export default EmailSettings;
